<button
    class="riege-button"
    mat-button
    aria-label="Change language"
    i18n-aria-label="@@aria-label-language-switch"
    data-testid="btn-language-switch"
    [matMenuTriggerFor]="languageSwitch"
    (menuOpened)="toogleMenu()"
    (menuClosed)="toogleMenu()">
    <mat-icon class="riege-icon">language</mat-icon>
    {{ currentLanguage.slice(0, 2) | uppercase }}
    <mat-icon iconPositionEnd class="riege-icon" aria-hidden="true">{{
        isClosed ? 'arrow_drop_down' : 'arrow_drop_up'
    }}</mat-icon>
</button>
<mat-menu
    #languageSwitch="matMenu"
    hasBackdrop="true"
    [yPosition]="position()"
    data-testid="btn-language-menu"
    class="riege-menu">
    @for (language of sortedLanguages; track $index) {
        <button
            class="riege-button"
            mat-menu-item
            role="menuitem"
            [class.active]="language[0] === currentLanguage"
            (click)="changeLanguage(language[0])">
            {{ language[1] | capitalize }}
        </button>
    }
</mat-menu>
